export default "__VITE_ASSET__f71c4306__"